import React, { useState } from 'react';
import { toast } from 'react-toastify';
import api from '../services/api';
import verifyEmailBg from './verify-email-bg.png';
import './Auth.css';

const EmailVerification = ({ email, emailError, onVerificationComplete, onBackToLogin }) => {
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);

  const handleResendEmail = async () => {
    if (!email) {
      toast.error('Email address not found');
      return;
    }

    setResending(true);
    try {
      const res = await api.post('/resend-verification', { email });
      if (res.data.email_sent) {
        toast.success('Verification email sent! Please check your inbox.');
      } else {
        toast.warning(res.data.email_error || res.data.message || 'Email could not be sent.');
      }
    } catch (error) {
      const msg = error.response?.data?.email_error || error.response?.data?.error || 'Failed to resend email';
      toast.error(msg);
    } finally {
      setResending(false);
    }
  };

  return (
    <div 
      className="auth-page-wrapper"
      style={{
        backgroundImage: `url(${verifyEmailBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat'
      }}
    >
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
            <img src="/cloudfish-logo.png" alt="CloudFish Logo" className="logo-image logo-cloudfish" style={{ height: '60px' }} />
          </div>
          <h1>Verify Your Email</h1>
          <p>{emailError ? "We couldn't send the verification email" : "We've sent a verification link to your email"}</p>
        </div>
        
        <div className="verification-content">
          <div className="email-display">
            <strong>{email}</strong>
          </div>
          {emailError && (
            <div className="verification-error" style={{ marginBottom: '1rem', padding: '0.75rem', background: '#fff3cd', borderRadius: '6px', fontSize: '0.9rem', color: '#856404' }}>
              <strong>Why:</strong> {emailError}
            </div>
          )}

          <div className="verification-instructions">
            <h3>Next Steps:</h3>
            <ol>
              <li>Check your email inbox</li>
              <li>Look for an email from HCM Query Tool</li>
              <li>Click the verification link in the email</li>
              <li>You'll be automatically logged in</li>
            </ol>
          </div>

          <div className="verification-tips">
            <h4>Tips</h4>
            <ul>
              <li>Check your spam/junk folder if you don't see the email</li>
              <li>The verification link expires in 24 hours</li>
              <li>Make sure to click the link from the same browser</li>
            </ul>
          </div>

          <div className="verification-actions">
            <button
              onClick={handleResendEmail}
              className="btn-resend"
              disabled={resending}
            >
              {resending ? 'Sending...' : 'Resend verification email'}
            </button>

            <button
              onClick={onBackToLogin}
              className="btn-back"
            >
              ← Back to Login
            </button>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default EmailVerification;

